import { RequestType } from '../../../../Service/RequestType';
import { callService } from '../../../../Service/ServiceBase';
import {
  CustomerMassQueryResult,
  ExecuteMassCustomerQuery,
  FavoriteQuery,
  NewFavoriteQuery,
} from '../types/query';

class QueryService {
  saveFavoriteQuery = async (
    queryObject: NewFavoriteQuery,
  ): Promise<FavoriteQuery> => {
    return await callService(
      'query',
      'favorites',
      RequestType.POST,
      queryObject,
    );
  };

  deleteFavoriteQuery = async (queryId: string): Promise<string> => {
    return await callService(
      'query',
      `favorites/${queryId}/delete`,
      RequestType.DELETE,
    );
  };

  getFavorites = async (): Promise<FavoriteQuery[]> => {
    return await callService('query', 'favorites', RequestType.GET);
  };

  async executeCustomerQuery(
    executeCustomerQuery: ExecuteMassCustomerQuery,
  ): Promise<CustomerMassQueryResult> {
    const result = await callService(
      'query',
      'execute',
      RequestType.POST,
      executeCustomerQuery,
    );
    return result;
  }
}

export const queryService: QueryService = new QueryService();
